<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <table class="table table-sm" v-if="!isMobile">
        <thead class="thead-light">
        <tr>
          <th>{{ 'protocol.protocol' | trans }}</th>
          <th>{{ 'user.client' | trans }}</th>
          <th>{{ 'protocol.stage' | trans }}</th>
          <th>{{ 'protocol.measured' | trans }}</th>
          <th>{{ 'protocol.measurement_date' | trans }}</th>
        </tr>
        </thead>
        <tbody>
        <tr v-if="loading">
          <td colspan="6">
            <loader class="table-loader" messages="home.labels.loading_message_table"/>
          </td>
        </tr>
        <tr v-for="item in items" :key="item.id" v-if="!loading && !isEmptyMeasurements">
          <td class="wide-col">
            <router-link
              :to="{ name: 'results', params: { protocolId: item.assignedProtocolId }}">
              <div class="icon-circle icon-purple"><span v-if="!isMobile">{{'user.P' | trans }}</span></div>
              <strong>{{ item.protocolTitle }}</strong>
            </router-link>
          </td>
          <td>
            <router-link :to="{ name: 'client-edit', params: { clientId: item.clientId }}">
              {{ item.clientCode }}
            </router-link>
          </td>
          <td>{{ item.stageTitle }}</td>
          <td>{{ `user.${item.auditorTypeName }` | trans }}</td>
          <td>{{ item.updatedAt | toLocaleDate }}</td>
        </tr>
        </tbody>
      </table>

        <div class="mobile-table" v-else>
          <div class="mobile-table__body">
            <div class="d-flex" v-if="loading">
              <loader class="table-loader" messages="home.labels.loading_message_table"></loader>
            </div>

            <div class="mobile-table__row" v-for="item in items" :key="item.id" v-if="!loading && !isEmptyMeasurements">
              <div class="title d-flex align-items-center justify-content-between">
                <router-link
                    :to="{ name: 'results', params: { protocolId: item.assignedProtocolId }}">
                  <div class="icon-circle icon-purple"></div>
                  <strong>{{ item.protocolTitle }}</strong>
                </router-link>
              </div>

              <div class="description pt-2">
                <div>
                  <p class="gray-dark">{{ 'protocol.stage' | trans }}</p>
                  <p>{{ item.stageTitle }}</p>
                </div>

                <div>
                  <p class="gray-dark">{{ 'protocol.measured' | trans }}</p>
                  <p>{{ `user.${item.auditorTypeName }` | trans }}</p>
                </div>

                <div>
                  <p class="gray-dark">{{ 'protocol.measurement_date' | trans }}</p>
                  <p>{{ item.updatedAt | toLocaleDate }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="text-center" v-if="isEmptyMeasurements && !loading">
      <h5>{{'user.no_data' | trans }}</h5>
    </div>


    <div class="row mt-2 mt-md-0">
      <div class="col-md-12 col-lg-5">
        <nav class="nav justify-content-center justify-content-md-start" v-show="paginate.lastPage > 1">
          <paginate :page-count="paginate.lastPage"
                    :page-range="paginate.pageRange"
                    :margin-pages="paginate.marginPages"
                    :initial-page="paginate.page"
                    :force-page="paginate.forcePage"
                    :click-handler="onPaginationClick"
                    :container-class="'pagination pagination-sm'"
                    :page-class="'page-item'"
                    :page-link-class="'page-link'">
            <span slot="prevContent" class="page-link">&laquo;</span>
            <span slot="nextContent" class="page-link">&raquo;</span>
          </paginate>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import {pagination} from '../../../../common/mixins/pagination'
  import Loader from '../../../loader/components/Loader'
  import ProtocolApiManager from '../../../../common/protocol/api/protocol'
  import isEmpty from 'lodash/isEmpty';

  export default {
    components: {Loader},
    mixins: [pagination],

    name: 'Measurements',
    props: {
      userId: {
        required: true,
        type: [Number, String],
      },
    },
    data () {
      return {
        items: [],
        state: {
          created: false,
          loadingCount: 0,
        },
      }
    },
    computed: {
      ...mapGetters('mobile', [
        'isMobile',
      ]),
      loading: {
        get: function () {
          return this.state.loadingCount > 0
        },
        set: function (newVal) {
          if (newVal === false) {
            this.state.loadingCount--
            return
          }
          this.state.loadingCount++
        },
      },
      lastPage: function () {
        return this.paginate.lastPage
      },
      page: function () {
        return this.paginate.page
      },
      isEmptyMeasurements: function () {
        return isEmpty(this.items);
      },
    },
    async created () {
      this.state.created = false
      await this.fetchData()
      this.state.created = true
    },
    methods: {
      setLoading: function (state) {
        this.loading = state
        this.$emit('loading', state, this.state.created)
      },
      fetchData: async function () {
        try {
          this.setLoading(true)

          let response = await ProtocolApiManager.paginateLastSessions({
            userId: this.userId,
            perPage: this.paginate.perPage,
            page: this.paginate.page,
          })

          let {items, perPage, lastPage, currentPage} = response.data.data
          this.items = items
          this.setPaginate({perPage, lastPage, currentPage})
        } catch (e) {
          console.error(e)
        } finally {
          this.setLoading(false)
        }
      },
      onPaginationClick: function (pageNum) {
        this.onPaginationBtnClick(pageNum)
        this.fetchData()
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/modules/user/therapist/profile/Measurements.vue